import copy from "copy-to-clipboard";

const codeCopyTarget = document.getElementById("code-copy-target");
const codeTarget = document.getElementById("code-container");
const codeTooltip = document.getElementById("code-tooltip");
const codeTooltipPopup = document.getElementById("code-tooltip-popup");

export const setCode = (code: string, preLabel: string, postLabel: string) => {
  if (codeCopyTarget && codeTarget && codeTooltip && codeTooltipPopup) {
    codeCopyTarget.onclick = () => {
      copy(code);

      codeTooltip.innerText = postLabel;
      codeTooltipPopup.innerText = postLabel;

      // set instructions back to normal after some time
      setTimeout(() => {
        codeTooltip.innerText = preLabel;
        codeTooltipPopup.innerText = preLabel;
      }, 5000);
    };

    codeTarget.innerText = code;

    codeTooltip.innerText = preLabel;
    codeTooltipPopup.innerText = preLabel;
  }
};
